import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { callAPIWithoutAuth } from '../../utils/apiUtils';
import { apiUrls } from '../../utils/apiUrls';

export const fetchBrands = createAsyncThunk(
    'brand/fetchBrands',
    async (limit = null, { rejectWithValue }) => {
        try {
            const params = {};
            if (limit !== null) {
                params.limit = limit;
            }
            const response = await callAPIWithoutAuth(
                apiUrls.brands,
                params,
                "GET",
                {}
            );

            if (response?.data?.success) {
                return response.data.data;
            } else {
                return rejectWithValue(response?.data?.message || 'Failed to fetch brands');
            }
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || 'Network error');
        }
    }
);

export const fetchAllBrands = createAsyncThunk(
    'brand/fetchAllBrands',
    async (_, { rejectWithValue }) => {
        try {
            const response = await callAPIWithoutAuth(
                apiUrls.allBrands,
                {},
                "GET",
                {}
            );

            if (response?.data?.success) {
                return response.data.data;
            } else {
                return rejectWithValue(response?.data?.message || 'Failed to fetch all brands');
            }
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || 'Network error');
        }
    }
);

export const fetchBrandDetails = createAsyncThunk(
    'brand/fetchBrandDetails',
    async (brandId, { rejectWithValue }) => {
        try {
            const response = await callAPIWithoutAuth(
                `${apiUrls.brandDetails}/${brandId}`,
                {},
                "GET",
                {}
            );

            if (response?.data?.success) {
                return response.data.data;
            } else {
                return rejectWithValue(response?.data?.message || 'Failed to fetch brand details');
            }
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || 'Network error');
        }
    }
);

const brandSlice = createSlice({
    name: 'brand',
    initialState: {
        brands: [],
        allBrands: [],
        brandDetails: null,
        loading: false,
        allBrandsLoading: false,
        detailsLoading: false,
        error: null
    },
    reducers: {
        clearBrandError: (state) => {
            state.error = null;
        },
        clearBrands: (state) => {
            state.brands = [];
            state.allBrands = [];
            state.brandDetails = null;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchBrands.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchBrands.fulfilled, (state, action) => {
                state.loading = false;
                state.brands = action.payload;
            })
            .addCase(fetchBrands.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            
            .addCase(fetchAllBrands.pending, (state) => {
                state.allBrandsLoading = true;
                state.error = null;
            })
            .addCase(fetchAllBrands.fulfilled, (state, action) => {
                state.allBrandsLoading = false;
                state.allBrands = action.payload;
            })
            .addCase(fetchAllBrands.rejected, (state, action) => {
                state.allBrandsLoading = false;
                state.error = action.payload;
            })
            
            .addCase(fetchBrandDetails.pending, (state) => {
                state.detailsLoading = true;
                state.error = null;
            })
            .addCase(fetchBrandDetails.fulfilled, (state, action) => {
                state.detailsLoading = false;
                state.brandDetails = action.payload;
            })
            .addCase(fetchBrandDetails.rejected, (state, action) => {
                state.detailsLoading = false;
                state.error = action.payload;
            });
    }
});

export const { clearBrandError, clearBrands } = brandSlice.actions;
export default brandSlice.reducer;